import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AllSalaryAddPopup from "../../../../components/modelpopup/AllSalaryAddPopup";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import ResumeListFilter from "../components/ResumeListFilter";
import { Table, Pagination } from "antd";
import { formatDateWithTimeHandler } from "utils/common";
import {
  itemRender,
  pageSizeOptions,
} from "utils/table";

import { SkeltonLoader } from "components/skeltonLoader";
import FilterDrawer from "components/Drawer/resumeFilterDrawer";
import { useResume } from "../context/resumeContext";
import ResumeStatusModal from "../../../../components/modelpopup/resumeStatusModalPopup";
import { getResumeDetailApi } from "api/services/resume";
import ApplicantDetailsPanel from "components/ApplicantDetailsPanel";
import JobSelectionModal from "../../../../components/modelpopup/JobSelectionModal";
import ReferralApplicationModal from "../../../../components/modelpopup/ReferralApplicationModal";
import { Button } from "components/Button";

const AllResume = () => {
  const {
    loading,
    searchText,
    resumeData,
    view,
    setView,
    resumeModal,
    setResumeModal,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    
    handleResumeDetailPage,
    handleDateChange,
    handleClearAll,
    getResumeList,
    isFilterDirty
  } = useResume();


  // Add new state for referral modals
  const [showJobSelectionModal, setShowJobSelectionModal] = useState(false);
  const [showReferralModal, setShowReferralModal] = useState(false);
  const [selectedJobForReferral, setSelectedJobForReferral] = useState(null);

  const [selectedResume, setSelectedResume] = useState([]);
  const [resumeStatusModal, setResumeStatusModal] = useState(false);
  const [expandedRowData, setExpandedRowData] = useState({});
  const [expandLoading, setExpandLoading] = useState({});
 
  // Function to fetch applicant details when row is expanded
  const fetchApplicantDetails = async (id) => {
    setExpandLoading(prev => ({ ...prev, [id]: true }));
    try {
      const response = await getResumeDetailApi(id, {});
      setExpandedRowData(prev => ({ ...prev, [id]: response.data }));
    } catch (error) {
      console.error("Error fetching applicant details:", error);
    } finally {
      setExpandLoading(prev => ({ ...prev, [id]: false }));
    }
  };

  const handleJobSelect = (job) => {
    setSelectedJobForReferral(job);
    setShowReferralModal(true);
  };

  const handleReferralModalClose = () => {
    setShowReferralModal(false);
    setSelectedJobForReferral(null);
  };

  // Render expanded content
  const expandedRowRender = (record) => (
    <ApplicantDetailsPanel data={expandedRowData[record.id]} loading={expandLoading[record.id]} />
  );

  const columns = [
    {
      title: "Applicant Name",
      dataIndex: "first_name",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {record.first_name} {record.last_name}
        </span>
      ) 
    },
   
    {
      title: "Job Title",
      dataIndex: "job",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {record.job.title}
        </span>
      )   
    
    },
    {
      title: "Applied On",
      dataIndex: "created_at",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {formatDateWithTimeHandler(record.created_at)}
        </span>
      )   
    
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {record.email}
        </span>
      )   
    
    },
  
  
    {
      title: "Phone",
      dataIndex: "phone",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {record.phone }
        </span>
      )   
    },
    {
      title: "Nationality",
      dataIndex: "nationality",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {record?.nationality?.name }
        </span>
      )   
    },
    {
      title: "Residency Status",
      dataIndex: "residence_status",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          <span className="badge text-bg-secondary">{record?.residence_status}</span>
          {/* {record?.residence_status } */}
        </span>
      )   
    },

    {
      title: "Gender",
      dataIndex: "gender",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          <span className="badge text-bg-secondary">{record?.gender}</span>
          {/* {record?.residence_status } */}
        </span>
      )   
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: true,
      render: (text, record) => (
        <div className="dropdown action-label text-center">
        <span className={`badge badge-soft-${ text == "applied" ?  "warning" : text == "rejected" ? "danger" : "success"}`}>{text}</span>  
  
  
        </div>
      )   
    },
    // {
    //   title: "Resume",
    //   dataIndex: "resume",
    //   render: (text, record) => (
    //     <Link to={text} className="btn btn-sm btn-primary" target="_blank" rel="noopener noreferrer">
    //       <i className="fa fa-download me-1" /> Download
    //     </Link>
    //   ),
    //   sorter: (a, b) => a.applicants?.length - b.applicants?.length,
    // },

    // {
    //   title: "Total Score",
    //   dataIndex: "total_score",
    //   sorter: true,
    
    // },
    // {
    //   title: "Action",
    //   dataIndex: "status",
    //   className: "text-end",
    //   // sorter: true,
    //   render: (text,record) => (
    //     <div className="dropdown dropdown-action text-end">
    //          {/* <Link
    //           className="btn btn-white btn-sm btn-rounded dropdown-toggle"
    //           to="#"
    //           data-bs-toggle="dropdown"
    //           aria-expanded="false"
    //         >
    //           <i
    //             className={
    //               text === "new"
    //                 ? "far fa-dot-circle text-purple"
    //                 : text === "pending"
    //                 ? "far fa-dot-circle text-info"
    //                 : text === "approved"
    //                 ? "far fa-dot-circle text-success"
    //                 : "far fa-dot-circle text-danger"
    //             }
    //           />{" "}
    //           {text}
    //         </Link> */}
  
    //         {/* <div className="dropdown-menu dropdown-menu-right">
    //           <Link className="dropdown-item" to="#">
    //             <i className="far fa-dot-circle text-purple" /> Applied
    //           </Link>
    //           <Link className="dropdown-item" to="#">
    //             <i className="far fa-dot-circle text-info" /> Shortlisted
    //           </Link>
    //           <Link className="dropdown-item" to="#">
    //             <i className="far fa-dot-circle text-success" /> Hired
    //           </Link>
    //           <Link className="dropdown-item" to="#">
    //             <i className="far fa-dot-circle text-danger" /> Rejected
    //           </Link>
    //         </div> */}
    //       <Link
    //         to="#"
    //         className="action-icon dropdown-toggle"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //       >
    //         <i className="material-icons">more_vert</i>
    //       </Link>
    //       <div className="dropdown-menu dropdown-menu-right">
    //         <Link
    //           className="dropdown-item"
    //           to="#"
    //           onClick={()=>{
    //             setSelectedResume(record)
    //             setResumeStatusModal(true)
    //           }}
    //         >
    //           <i className="fa fa-pencil m-r-5" /> Change Status
    //         </Link>
          
    //       </div>
    //     </div>
    //   ),
    // },
    
  ];

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {resumeData.map((resume, index) => (
            <div
              className="col-md-6 col-sm-1 col-12 col-lg-3 col-xl-4"
              key={resume.id}
            >
              <div className="profile-widget">
               
                <div className="dropdown profile-action">
                  <Link
                    to="#"
                    className="action-icon dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="material-icons">more_vert</i>
                  </Link>
                 
                  <div className="dropdown-menu dropdown-menu-right">
              

                    <Link
                      className="dropdown-item"
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#edit_resume"
                    >
                      <i className="fa fa-pencil m-r-5" /> Edit
                    </Link>
                    <Link
                      className="dropdown-item"
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#delete"
                    >
                      <i className="fa-regular fa-trash-can m-r-5" /> Delete
                    </Link>

                    <Link
                      className="dropdown-item"
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#download_resume"
                    >
                      <i className="fa fa-download m-r-5" /> Download Resume
                    </Link>
                  </div>
                </div>
                <div className="row" >
         
                 
                  <div  className="col-12" >
                  <h4 className="user-name m-t-10 mb-0 text-ellipsis text-start">
                  <a onClick={()=>handleResumeDetailPage(resume.id, index)}>
                  {resume?.name} {"  "} 
                  </a>
                </h4>

                  <h5 className="user-name m-t-10 mb-0 text-ellipsis text-start">
                  <a onClick={()=>console.log("bla")}
                  >
                   <div className=" action-label ">
                      <Link
                        className="btn btn-white btn-sm btn-rounded "
                        to="#"
                       
                        aria-expanded="false"
                      >
                        
                        <i
                          className={
                            resume?.status === "shortlisted"
                              ? "far fa-dot-circle text-info"
                              :  resume?.status === "closed"
                              ? "far fa-dot-circle text-success"
                              : "far fa-dot-circle text-danger"
                          }
                        />{" "}
                        { resume?.status}
                      </Link>
                     
                    </div>
                  </a>
                </h5>
                <div className="m-t-10 small text-muted text-start">{resume?.email}</div>
                <div className="m-t-10 small text-muted text-start">{resume?.job.title}</div>

                <div className="small text-muted text-start">{resume.role}</div>

                  </div>
                  
                    </div>
                

              </div>
            </div>
          ))}
        </>
      );
    }
  };


  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Employee Referrals"
            title="Dashboard"
            subtitle="Job / Employee Referrals"
            modal="#add_resume"
            name="Add Resume"          
            view={view}
            setSalaryModal={setResumeModal}
            setView={setView}
          />

          {/* Add Refer a Friend Button */}
          <div className="row mb-3">
            <div className="col-12">
              <Button
                onClick={() => setShowJobSelectionModal(true)}
                label="Refer a Friend"
                className="btn btn-primary"
                icon={<i className="fa fa-user-plus me-2"></i>}
              />
            </div>
          </div>

          {/* <ResumeListFilter
           filters={filters} 
           handleInputChange={handleInputChange} 
           searchPlaceholder={"Search Employee Referrals"} 
           handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
          /> */}



          {view == "grid" ? (
            <div className="row">    
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                  <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    itemRender={itemRender}
                    onChange={handleGridChange}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-12">
                <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                  <style>{`
                    .modern-table .ant-table-tbody > tr {
                      background-color: #ffffff !important;
                    }
                    .modern-table .ant-table-tbody > tr:hover > td {
                      background-color: #f5f5f5 !important;
                    }
                    .modern-table .ant-table-thead > tr > th {
                      background-color: #f8f9fa !important;
                      font-weight: 600;
                      color: #333;
                      border-bottom: 2px solid #e0e0e0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-tbody > tr > td {
                      border-bottom: 1px solid #f0f0f0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                      border-top: 1px solid #f0f0f0;
                      background-color: #ffffff;
                      border-bottom-left-radius: 12px;
                      border-bottom-right-radius: 12px;
                    }
                  `}</style>
                  <div className="table-responsive" style={{ overflowX: "auto" }}>
                    <Table
                      className="mb-0 modern-table"
                      style={{ 
                        borderRadius: "12px",
                        minWidth: "100%"
                      }}
                      scroll={{ x: "max-content" }}
                      columns={columns}
                      dataSource={resumeData}
                      rowKey={(record) => record.id}
                      loading={loading}
                      pagination={{
                        total: pageSettings?.total,
                        pageSize: pageSettings?.pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: pageSizeOptions,
                        itemRender: itemRender,
                        position: "right",
                        current: pageSettings?.page,
                        showTotal: (total, range) =>
                          `${range[0]}-${range[1]} of ${total} items`,
                        style: { padding: "16px" }
                      }}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <AllSalaryAddPopup />
      {/* Delete Modal */}
      <DeleteModal Name="Delete Salary" />

      <FilterDrawer
          searchPlaceholder={"Search Salary"}
          showFilterDrawer={showFilterDrawer}
          handleFilterDrawer={handleFilterDrawer}

          handleFilterChange={handleFilterChange}
          filters={filters}
          handleInputChange={handleInputChange}
          handleApplyFilter={handleApplyFilter}
          filterLoading={filterLoading}
          handleDateChange={handleDateChange}
          handleClearAll={handleClearAll}
          isFilterDirty={isFilterDirty}
/>
      {/* Delete Modal */}

      <ResumeStatusModal getResumeList={getResumeList} selectedResume={selectedResume} setSelectedResume={setSelectedResume}   resumeStatusModal={resumeStatusModal} setResumeStatusModal={setResumeStatusModal} />

      {/* Job Selection Modal */}
      <JobSelectionModal
        visible={showJobSelectionModal}
        onCancel={() => setShowJobSelectionModal(false)}
        onJobSelect={handleJobSelect}
      />

      {/* Referral Application Modal */}
      <ReferralApplicationModal
        visible={showReferralModal}
        onCancel={handleReferralModalClose}
        selectedJob={selectedJobForReferral}
        onSuccess={getResumeList}
      />

      {/* Add custom CSS for expanded row */}
      <style jsx>{`
        .question-answers {
          padding: 0;
        }
        .qa-item {
          transition: all 0.2s ease;
          border-bottom: 1px solid #eee;
        }
        .qa-item:last-child {
          border-bottom: none;
        }
        .qa-item:hover {
          background-color: #f9f9f9;
        }
        .compact-card .ant-card-head {
          min-height: 36px;
        }
        .compact-card .ant-card-head-title {
          padding: 4px 0;
        }
        .compact-card .ant-card-body {
          padding: 8px 12px;
        }
      `}</style>
    </div>
  );
};

export default AllResume;
